import { createFileRoute } from "@tanstack/react-router";
import { AuthorizationPageGate } from "@/features/admin/authorization/_components/authorization-page-gate";
import { MaskRedirect } from "@/features/shared/route-masking";

export const Route = createFileRoute("/admin/authorization/create")({
  component: () => (
    <AuthorizationPageGate>
      <MaskRedirect
        to="/admin/authorization"
        action="create"
        mask="/admin/authorization/create"
      />
    </AuthorizationPageGate>
  ),
});
